import React, { useMemo } from 'react';
import block from 'bem-cn';
import { shallowEqual } from 'react-redux';

import { useAppSelector } from 'shared/hooks';

import number1IMG from './img/number1.png';
import number2IMG from './img/number2.png';
import number3IMG from './img/number3.png';

import './Item.scss';

const b = block('balance-table-row-desktop');

const Item = ({ item, type }) => {
  const icon = useMemo(() => {
    if (item.rank === 1) return number1IMG;
    if (item.rank === 2) return number2IMG;
    if (item.rank === 3) return number3IMG;
    return '';
  }, [item.rank]);

  const rowClass = b({
    number: item.number,
    [type === 'players' ? 'six-columns' : 'four-columns']: true,
    top: Boolean(icon),
  });

  return (
    <div className={rowClass}>
      <div
        className={b('td', {
          icon: true,
        })}>
        {icon && (
          <div className={b('top-icon-wrapper')}>
            <img
              className={b('top-icon', {
                variant: item.rank,
              })}
              src={icon}
              alt=""
            />
          </div>
        )}
        <span className={b('td-value')}>{item.id}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{item.username}</span>
      </div>
      {/*<div className={b('td')}>*/}
      {/*  <span className={b('td-value')}>{item.directAgent}</span>*/}
      {/*  <span*/}
      {/*    className={b('td-value', {*/}
      {/*      rounded: true,*/}
      {/*    })}>*/}
      {/*    {item.currentAgent}*/}
      {/*  </span>*/}
      {/*</div>*/}
      <div className={b('td')}>
        <span className={b('td-value')}>{item.actualBalance}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{item.startBalance}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{item.endBalance}</span>
      </div>
      <div className={b('td')}>
        <span
          className={b('td-amount', {
            positive: item.changeBalance >= 0,
            negative: item.changeBalance < 0,
          })}>
          {item.changeBalance}
        </span>
      </div>
    </div>
  );
};

export default Item;
